@if (loading$ | async) {
  <section class="loader-wrapper" id="loaderitem">
    @if (loading$ | async) {
      <section class="loader-content">
        <mat-spinner class="spinner"  diameter=50 mode="indeterminate"></mat-spinner>
      </section>
    }
  </section>
}
<section class="loader-wrapper" id="loading" >
  <section class="loader-content" >
    <mat-spinner class="spinner"  diameter=50 mode="indeterminate"></mat-spinner>
  </section>
</section>
